import { inject, Injectable, signal } from '@angular/core';
import {
  SEU_CALC_OUTPUT_NAVBAR_MIN_HEIGHT,
  SEU_CALC_OUTPUT_SNAP_MIN,
} from '@seu-types';
import { firstValueFrom } from 'rxjs';
import { InfrastructureApiService } from 'src/app/shared/api';

@Injectable({
  providedIn: 'root',
})
export class CalculationOutputService {
  private readonly infrastructureApiService = inject(InfrastructureApiService);

  public readonly calculationOutputBarHeight = signal(
    SEU_CALC_OUTPUT_NAVBAR_MIN_HEIGHT
  );

  public readonly navbarPreviewHeight = signal(0);

  public openNavigationFlap(): void {
    if (this.calculationOutputBarHeight() <= SEU_CALC_OUTPUT_SNAP_MIN) {
      void firstValueFrom(
        this.infrastructureApiService.wakeUpMtbServiceWorker()
      );
    }
    this.updateBarHeight(this.navbarPreviewHeight());
  }

  public updateBarHeight(height: number): void {
    this.calculationOutputBarHeight.update(() => {
      if (height < SEU_CALC_OUTPUT_SNAP_MIN) {
        return SEU_CALC_OUTPUT_NAVBAR_MIN_HEIGHT;
      }
      if (
        height >
        document.documentElement.clientHeight - SEU_CALC_OUTPUT_SNAP_MIN
      ) {
        return document.documentElement.clientHeight;
      }
      return height;
    });
  }
}
